import { IMetricsTrackingData, ProcessPageTypeCodeEnum } from '@interfaces';
import { createAction, props } from '@ngrx/store';

export const submitMetricsOAStart = createAction('[Submit Metrics] Starting Submit Metrics');
export const submitMetricsOASuccess = createAction('[Submit Metrics] Open Account Success');
export const submitMetricsOAEnd = createAction(
  '[Submit Metrics] Ending Submit Metrics',
  props<{ payload: ProcessPageTypeCodeEnum }>(),
);
export const submitMetricUpdateProcessingId = createAction(
  '[Submit Metrics] Updating Submit Metrics Processing ID',
  props<{ payload: IMetricsTrackingData }>(),
);
export const submitMetricsFlowStart = createAction('[Submit Metrics] Flow Started');
export const submitMetricsFlowSubmit = createAction(
  '[Submit Metrics] Flow Submitted',
  props<{ payload: string }>(),
);
